export default {
    async getProductHistory(productId) {
        // Don't bother if we don't have a user
        if (!window.Alpine.store('user') || !window.Alpine.store('user').isLoggedIn) {
            return null
        }

        const localStore = window.Alpine.store('purchaseHistory')

        // If we do not have it in store, fetch.
        // Let's prevent duped requests by binding a var to the window
        if (localStore && (!localStore.value || localStore.ttl < Date.now()) && !window.fetchingHistory) {
            window.fetchingHistory = true
            await window.api.get('/m/accu/purchaseHistory').then((response) => {
                // Don't overwrite if we get nothing back because they got logged out for example
                if (!response.data) {
                    return
                }

                // Let's createa localStorage item with a ttl value to check if we need to refresh
                localStore.value = response.data
                localStore.ttl = (new Date()).getTime() + 60000 // 1 minute

                window.fetchingHistory = false
            })
        }

        if (localStore && localStore.value && productId in localStore.value) {
            return localStore.value[productId]
        }

        return null
    },
}
